module.exports = __webpack_public_path__ + "static/images/intro6_4b06dcaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/intro6.png
// module id = 234
// module chunks = 1